import { Dispatch, SetStateAction, useEffect, useState } from "react"

import { defaultVideoState } from "./VideoState"

// Manages subtitle state. Holds its own boolean state & updates the videoElement accordingly.
export const useSubtitlesVisible = (
  videoElement: HTMLVideoElement | null,
  canPlay: boolean,
): [boolean, Dispatch<SetStateAction<boolean>>] => {
  const [subtitlesVisible, setSubtitlesVisible] = useState(
    defaultVideoState.alreadyPlayed,
  )

  useEffect(() => {
    const trackListLength = videoElement?.textTracks.length ?? 0
    const textTrack = videoElement?.textTracks[trackListLength - 1]

    if (textTrack) {
      textTrack.mode = subtitlesVisible ? "showing" : "hidden"
    }
  }, [videoElement, subtitlesVisible])

  useEffect(() => {
    // turn any existing caption files off on startup.
    // HLS generated by FFMPEG has subtitles on by default.
    // We are making an assumption that there will only be one text track per video.
    if (canPlay) {
      const textTrack = videoElement?.textTracks[0]

      if (!textTrack) {
        return
      }
      textTrack.mode = "hidden"
    }
  }, [videoElement, canPlay])

  return [subtitlesVisible, setSubtitlesVisible]
}
